import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Wrapper from '../Home/homeWrapper/Wrapper'

const NotFound = () => {
    const {t} = useTranslation();

    return (
        <Wrapper>
            <div className='mt-5 pt-5'>
                <Container>
                    <Row className='d-flex align-items-center justify-content-center'>
                        <div className='col-md-6'>
                            <img className='' src="/assets/img/notfound.png" alt="404" style={{width: '100%', height: 'auto'}} />
                        </div>
                        <div className='col-md-6'>
                            <h4 className='text-center'>{t("Sorry, we did not find the page you are looking for")}</h4>
                            <div className='mt-5 d-flex align-items-center justify-content-center'>
                                <Link to="/" className='col-md-5 mx-2 btn btn-lg btn-success'>{t("home page")}</Link>
                                <Link to="/exhibition" className='col-md-5 mx-2 btn btn-lg btn-danger'>{t("visit the exhibition")}</Link>
                            </div>
                        </div>

                    </Row>
                </Container>
            </div>
        </Wrapper>
    )
}

export default NotFound
